import React from 'react';

function CTA() {
  const navigateToServices = (e) => {
    e.preventDefault();
    window.location.href = '/#services';
  };

  return (
    <div className="cta-section">
      <h1>Ready to take the next step? We would love to help you</h1>
      {/* <p>Get started with rKube Services today and discover the perfect solutions for your business needs.</p> */}
      <a href="/#services" onClick={navigateToServices} className="cta-button">Signup Now</a>
    </div>
  );
}

export default CTA;